import { render, staticRenderFns } from "./OtoTab.vue?vue&type=template&id=18343ec4&scoped=true"
import script from "./OtoTab.vue?vue&type=script&lang=js"
export * from "./OtoTab.vue?vue&type=script&lang=js"
import style0 from "./OtoTab.vue?vue&type=style&index=0&id=18343ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18343ec4",
  null
  
)

export default component.exports